module.exports = __webpack_public_path__ + "static/media/verisk-nosavi_1x.10b297ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/verisk-nosavi_1x.svg
// module id = 621
// module chunks = 0